import React from 'react';
import { Chip, ChipProps, styled, Tooltip } from '@material-ui/core';

const StyledChip = styled(Chip)({
  minWidth: 0,
  maxWidth: '100%',
  '& .MuiChip-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export interface TruncatedChipProps extends Omit<ChipProps, 'label'> {
  label: string;
  tooltip?: React.ReactNode;
}

export const TruncatedChip = ({
  label,
  tooltip,
  ...chipProps
}: TruncatedChipProps) => {
  const chip = <StyledChip label={label} {...chipProps} />;

  if (!tooltip) {
    return chip;
  }

  return <Tooltip title={tooltip}>{chip}</Tooltip>;
};
